// extracted by mini-css-extract-plugin
module.exports = {"Progress":"Progress_Progress__19euZ","Step":"Progress_Step__3Oiot","previous":"Progress_previous__2-0HF","dot":"Progress_dot__23b6S","current":"Progress_current__3crH_"};